import { useCallback } from 'react'

interface UseGuardedActionOptions {
  isBlocked: boolean
  openBlockingModal: () => void
  proceed: () => void
}

export const useGuardedAction = ({ isBlocked, openBlockingModal, proceed }: UseGuardedActionOptions): (() => void) =>
  useCallback(() => {
    if (isBlocked) {
      openBlockingModal()
    } else {
      proceed()
    }
  }, [isBlocked, openBlockingModal, proceed])
